// 🔒 AVISO-RNC-2026-10-29 — Dígito verificador del RNC (9 dígitos), el mismo cálculo de la DGII:
// pesos 7,9,8,6,5,4,3,2 sobre los 8 primeros; m = suma % 11; dígito = 2 si m es 0, 1 si m es 1, si no 11 − m.
// Cuadró con los 17 RNC reales del 607 de PON PAN y atrapó el RNC mal escrito (132672956).
// Hay RNC viejos que no cumplen la regla: por eso solo avisa y no bloquea, y si la DGII lo encuentra no se avisa.
const PESOS = [7, 9, 8, 6, 5, 4, 3, 2];

export function rncDigitoValido(valor) {
  const d = String(valor || '').replace(/\D/g, '');
  if (d.length !== 9) return null;            // no es RNC: no aplica
  const suma = PESOS.reduce((s, p, i) => s + p * Number(d[i]), 0);
  const m = suma % 11;
  const digito = m === 0 ? 2 : m === 1 ? 1 : 11 - m;
  return digito === Number(d[8]);
}

export default rncDigitoValido;
